import { SearchFilter } from './searchfilter';

export class BaseQueryDTO {
    SearchFilter: SearchFilter;
}
